import React, { useEffect } from 'react';
import AnimalListEntry from './AnimalListEntry';
import { getDaysSince } from '../utilities/time';

function getAnimalKey(entry: any) {
  return String(
    entry._id
    ?? entry.tagId
    ?? [entry.species, entry.name, entry.group, entry.dateTagged].filter(Boolean).join(':')
  );
}


export default function SpeciesList(props: any) {
  const { onSelected, onClickOutside, group } = props;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      onClickOutside && onClickOutside(event);
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  return (
    <div className={`species-popup species-popup-animals${props.inlineDesktop ? ' species-popup-animals--inline' : ''}`}>
      <p className='species-popup-header'>{group.individuals.length} Tracked {props.name}</p>
      {group.individuals.length !== 0
        ? (
          <ul className='species-list'>
            {group.individuals
              .map((entry: any) => {
                return (<AnimalListEntry key={getAnimalKey(entry)} item={entry} lastPing={getDaysSince(entry)} onSelected={onSelected} />)
              }).sort((a: any, b: any) => {
                return a.props.lastPing - b.props.lastPing
              })}
          </ul>
        )
        : <div style={{ margin: 'auto auto', width: '100%', textAlign: 'center' }}>COMING SOON</div>
      }
    </div>
  )
}